// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2jIA5","col":"styles_col__1FgI2"};